import React, { Suspense } from "react";
import animationData from "./animation.json";
import WorkOwlFullWigns from "./WorkOwlFullWigns";
const Lottie = React.lazy(() => import("lottie-react"));

const WorkOwlAnimation = () => (
    <Suspense fallback={<WorkOwlFullWigns width={350}/>}>
        <Lottie style={{ width: 350 }} animationData={animationData} loop />
    </Suspense>
);


export default WorkOwlAnimation;
